import { render, staticRenderFns } from "./user-session.vue?vue&type=template&id=4d0c8972&scoped=true&"
import script from "./user-session.vue?vue&type=script&lang=js&"
export * from "./user-session.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0c8972",
  null
  
)

export default component.exports